import { render, staticRenderFns } from "./trainingQuiz.vue?vue&type=template&id=62fbb1ec"
import script from "./trainingQuiz.vue?vue&type=script&lang=js"
export * from "./trainingQuiz.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports